<script lang="ts">
	import closeIcon from "@assets/icons/close.svg?raw";
	import iconInfo from "@assets/icons/info.svg";
	import menuIcon from "@assets/icons/menu.svg?raw";
	import logoIntimex from "@assets/images/logo-intimex.svg";
	import Button from "@components/common/Button.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { ButtonSize, ButtonVariant } from "@components/common/getButtonClass.js";
	import type { MenuItem } from "@core/schema/MenuItem.js";
	import { contactPhoneNumber } from "@core/schema/contact.js";
	import { getDemandPath } from "@core/schema/paths/getDemandPath.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { lockScroll } from "../../state/lockScroll.svelte.js";

	const { menu, headerBgAnimation }: { menu: MenuItem[]; headerBgAnimation?: boolean } = $props();
	const { tenant } = getGlobalTemplateProps();

	let scrollY = $state(0);
	let headerHeight = $state(0);
	let mobileMenuOpen = $state(false);

	const isWhite = $derived(scrollY > headerHeight || !headerBgAnimation || mobileMenuOpen);
</script>

<svelte:window bind:scrollY />

<header
	bind:clientHeight={headerHeight}
	class={[
		"lg:grid-container grow py-2 lg:py-4 fixed z-50 left-0 right-0 mx-auto transition-colors duration-150",
		isWhite ? "bg-white" : "bg-transparent",
	]}
>
	<div class="flex flex-col lg:flex-row justify-between items-center">
		<div class="max-lg:grid-container max-lg:w-full z-50">
			<div class="flex items-center justify-between max-lg:w-full lg:items-start">
				<Link href={getHomepagePath(tenant)}>
					<Media width={129.11} height={32} alt="Intimex logo" source={{ src: logoIntimex, type: "image/svg+xml" }}
					></Media>
				</Link>
				<Button
					variant={ButtonVariant.Outline}
					aria-label="Menu"
					class="duration-300 transition-all min-w-fit block lg:hidden !px-2 !py-2"
					onclick={(): void => {
						mobileMenuOpen = !mobileMenuOpen;
						lockScroll.lock = mobileMenuOpen;
					}}
				>
					<Icon class="w-4" square icon={mobileMenuOpen ? closeIcon : menuIcon} />
				</Button>
			</div>
		</div>

		<div
			class="flex flex-col z-10 bg-white h-full max-lg:fixed top-12 max-lg:w-full lg:h-auto lg:bg-transparent lg:flex-row items-center gap-10 transition-[transform,background-color]"
			class:max-lg:pointer-events-none={!mobileMenuOpen}
			class:max-lg:translate-x-full={!mobileMenuOpen}
		>
			<ul class="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-4 mt-10 lg:mt-0">
				{#each menu as menuItem, index (index)}
					<li>
						<Link
							class="px-2 py-2 uppercase text-xs tracking-widest text-lightblue font-semibold"
							href={menuItem.href}
							target={menuItem.target}
						>
							{menuItem.name}
						</Link>
					</li>
				{/each}
			</ul>
			<Link
				class="border-lightblue !bg-transparent"
				variant={ButtonVariant.Outline}
				size={ButtonSize.Sm}
				href={getDemandPath(tenant)}
			>
				Poptat
			</Link>
			<div class="flex gap-1 items-center">
				<Media width={18} height={18} alt="Info icon" source={{ src: iconInfo, type: "image/svg+xml" }}></Media>
				<Link
					class="pl-1 uppercase text-sm leading-5 tracking-widest text-blue font-semibold"
					href="tel:{contactPhoneNumber}"
				>
					{contactPhoneNumber}
				</Link>
			</div>
		</div>
	</div>
</header>
